import { ERROR_CHANGE_PASSWORD, ERROR_LOGIN, FILL_CHANGE_PASSWORD, FILL_LOGIN, InitialStateLogin, SET_CLAIMS, SET_USER, START_CHANGE_PASSWORD, START_LOGIN, STOP_CHANGE_PASSWORD, STOP_LOGIN } from "./types";

const initialState: InitialStateLogin = {
    login: {
        data: '',
        loading: false,
        error: null
    },
    changePassword: {
        data: '',
        loading: false,
        error: null
    },
    currentUser: {
        name: ''
    },
    claims: {
        data: []
    }
}

export const authReducer = (state = initialState, action: any) => {
    switch (action.type) {

        case START_LOGIN:
            return {
                ...state,
                login: {
                    ...state.login,
                    loading: true,
                    error: null
                }
            }
        case STOP_LOGIN:
            return {
                ...state,
                login: {
                    ...state.login,
                    loading: false
                }
            }
        case FILL_LOGIN:
            return {
                ...state,
                login: {
                    ...state.login,
                    data: action.payload
                }
            }
        case ERROR_LOGIN:
            return {
                ...state,
                login: {
                    ...state.login,
                    error: action.payload
                }
            }




        case START_CHANGE_PASSWORD:
            return {
                ...state,
                changePassword: {
                    ...state.changePassword,
                    loading: true,
                    error: null
                }
            }
        case STOP_CHANGE_PASSWORD:
            return {
                ...state,
                changePassword: {
                    ...state.changePassword,
                    loading: false
                }
            }
        case FILL_CHANGE_PASSWORD:
            return {
                ...state,
                changePassword: {
                    ...state.changePassword,
                    data: action.payload
                }
            }
        case ERROR_CHANGE_PASSWORD:
            return {
                ...state,
                changePassword: {
                    ...state.changePassword,
                    error: action.payload
                }
            }

        case SET_USER:
            return {
                ...state,
                currentUser: {
                    name: action.payload
                }
            }
        case SET_CLAIMS:
            return {
                ...state,
                claims: {
                    data: action.payload
                }
            }

        default:
            return state
    }
}

